import { render, staticRenderFns } from "./SetConfirmStep.vue?vue&type=template&id=a2b9c5dc&scoped=true&"
import script from "./SetConfirmStep.vue?vue&type=script&lang=js&"
export * from "./SetConfirmStep.vue?vue&type=script&lang=js&"
import style0 from "./SetConfirmStep.vue?vue&type=style&index=0&id=a2b9c5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b9c5dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VChip,VDivider,VIcon,VSpacer,VSwitch,VTextField})
